import { useState, useEffect, useCallback, useRef } from "react";
import { useLocation, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { getCasinoGameDetails, getMatchExposure } from "@/services/casinoApi";
import CasinoHeading from "../components/common/CasinoHeading";
import VideoBox from "../components/common/VideoBox";
import BetTableTeenMuf from "../components/teenmuf/BetTableTeenMuf";
import ResultTeenMuf from "../components/teenmuf/ResultTeenMuf";
import RightSection from "../components/RightSection/RightSection";
import styles from "./TeenMuf.module.css";

function extractCasinoGame(url) {
  const match = url.match(/\/lord-games\/([^/?#]+)/);
  return match ? match[1] : null;
}

export default function TeenMuf() {
  const [gameData, setGameData] = useState({});
  const [activeTab, setActiveTab] = useState("game");
  const [iframeSrc, setIframeSrc] = useState("");
  const { pathname } = useLocation();
  const gameDataRef = useRef(gameData);
  useEffect(() => { gameDataRef.current = gameData; }, [gameData]);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [playerAScore, setPlayerAScore] = useState({});
  const [playerBScore, setPlayerBScore] = useState({});

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "teenmuf";
    setIframeSrc(`https://casino-stream.softgamingapi.com/casino-tv?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    // Start API calls after 5 seconds delay
    let intervalId = null;
    const initialTimeout = setTimeout(() => {
      fetchGameData();
      intervalId = setInterval(fetchGameData, 1500);
    }, 5000);

    return () => {
      clearTimeout(initialTimeout);
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [pathname]);

  useEffect(() => {
    if (gameData) {
      const subData = gameData?.data?.data?.sub || [];

      const d1 = [subData[0], subData[2], subData[4]];
      const d2 = [subData[1], subData[3], subData[5]];

      if (d1.length > 0) {
        setPlayerAScore({
          a: d1?.[0] || null,
          b: d1?.[1] || null,
          c: d1?.[2] || null,
        });
      }

      if (d2.length > 0) {
        setPlayerBScore({
          a: d2?.[0] || null,
          b: d2?.[1] || null,
          c: d2?.[2] || null,
        });
      }
    }
  }, [gameData]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id;
      const matchId = gameData?.data?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            exposureMap[item.team_name] = parseFloat(item.exposure_amount) || 0;
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error('Error fetching exposure:', error);
    }
  }, [gameData?.data?.data?.mid]);

  useEffect(() => {
    const matchId = gameData?.data?.data?.mid?.toString();
    if (!matchId) return;

    // Start exposure fetch after 5 seconds delay
    const timeoutId = setTimeout(() => {
      fetchExposure();
    }, 5000);

    const intervalId = setInterval(() => {
      fetchExposure();
    }, 5000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [gameData?.data?.data?.mid, fetchExposure]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleBetClick = (value, selection, betData, type) => {
    // Betting functionality can be added later (admin view - no bet login)
    console.log("Bet clicked:", { value, selection, betData, type });
  };

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.sectionA}>
          <CasinoHeading
            name="MUFLIS TEENPATTI"
            roundId={gameData?.data?.data?.mid || "157250124095658"}
            placedBetCount={myBets.length}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />

          {activeTab === "game" && (
            <>
              <VideoBox
                gameType="teenmuf"
                resultData={gameData?.data?.data?.card}
                iframeSrc={iframeSrc}
                timerValue={gameData?.data?.data?.lt}
              />

              <div className={styles.tableContainer}>
                <div className={styles.bettable}>
                  <BetTableTeenMuf
                    playerAScore={playerAScore}
                    playerBScore={playerBScore}
                    onBetClick={handleBetClick}
                    exposures={exposures}
                    min={gameData?.data?.data?.min || "100.0"}
                    max={gameData?.data?.data?.max || "200K"}
                  />
                </div>
              </div>

              <div className={styles.heading}>
                <div>Last Result</div>
                <Link to="/admin/reports/casinoresult/teenmuf">
                  <div className={styles.viewAll}>View All</div>
                </Link>
              </div>
              <ResultTeenMuf
                data={gameData?.data?.lrs || []}
                gameData={gameData}
              />
            </>
          )}
          {activeTab === "placedBet" && (
            <div className="mt-4 p-4 bg-[rgba(0,0,0,0.4)] rounded">
              <div className="text-white text-center text-xl">Coming Soon</div>
            </div>
          )}
        </div>

        <RightSection
          sectionKey="teenmuf"
          data={myBets}
          title="Matched"
          viewMoreText="View More"
          onViewMore={() => {
            console.log("View more clicked for teenmuf");
          }}
        />
      </div>
    </Layout>
  );
}

